import handleMultipleArgs from './_handleMultipleArgs';
import setRequestHeaders from './_setRequestHeaders';
import prepareRequest from './_prepareRequest';
import processHeaders from './_processHeaders';
import defaultPOST from './_defaultPOST';
import mergeConfig from './_mergeConfig';
import onError from './_onError';

/**
 * @public
 * Makes an AJAX request through `XMLHttpRequest`
 *
 * @param {Object} args: options to configure the request.
 *        It has the properties: {url, method, headers, async, data, credentials, onload}
 * @return {XMLHttpRequest}
 */
export default function ajax(...args) {
  const xhr = new XMLHttpRequest();
  const options = defaultPOST(handleMultipleArgs(args));
  const config = mergeConfig(options);
  prepareRequest(config);
  xhr.onerror = onError(config);
  xhr.ontimeout = onError(config);
  xhr.onreadystatechange = () => {
    if (xhr.readyState === 4) { // DONE: the operation is complete.
      let data = 'response' in xhr ? xhr.response : xhr.responseText;
      const isJSON = processHeaders.hasJSON(processHeaders.from(xhr));
      if (isJSON) data = data && JSON.parse(data);
      const callbacks = [].concat(config.onload);
      return callbacks.reduce((result, fn) => {
        if (typeof fn === 'function') {
          data = fn.call(xhr, result);
          if (data != null) return data;
        }
        return result;
      }, data);
    }
    return null;
  };
  if (typeof config.async !== 'boolean') config.async = true;
  xhr.open(config.method, config.url, config.async);
  // withCredentials for cross-domain requests
  if (config.credentials === 'include') {
    xhr.withCredentials = true;
  }
  if (options.data == null) config.data = null;
  setRequestHeaders(xhr, config.headers);
  xhr.send(config.data);
  return xhr;
}
